import { USERS_SERVICE } from "@/services/users.service.js";
import router from '@/router/index';

const user = JSON.parse(localStorage.getItem('user'));
const state = user
    ? { status: { loggedIn: true }, user, processTask: undefined }
    : { status: {}, user: null, processTask: undefined };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        dispatch('alert/clear', null, { root: true });
        commit('loginRequest', { username });
        
        USERS_SERVICE.login(username, password)
            .then(
                user => {
                    user.data.username = username;
                    commit('loginSuccess', user);
                    router.push('/');
                },
                error => {
                    commit('loginFailure', user);                
                    dispatch('alert/error', error, { root: true });

                }

            );
    },
    updatePassword({ dispatch, commit }, password) {
        dispatch('alert/clear', null, { root: true });
        commit('updatePasswordRequest');
        
        USERS_SERVICE.updatePassword(password)
            .then(
                output => {
                    commit('updatePasswordSuccess', output);
                },
                error => {
                    commit('updatePasswordFailure', user);                
                    dispatch('alert/error', error, { root: true });

                }

            );
    },
    requestLinkPassword({ dispatch, commit }, email) {
        dispatch('alert/clear', null, { root: true });
        commit('linkRequest');

        USERS_SERVICE.requestLink(email)
            .then(
                output => {
                    commit('linkSuccess');
                },
                error => {
                    commit('linkFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    resetPassword({ dispatch, commit }, {username, password, token}) {
        dispatch('alert/clear', null, { root: true });
        commit('resetPasswordRequest');

        USERS_SERVICE.resetPassword(username, password, token)
            .then(
                output => {
                    commit('resetPasswordSuccess');
                },
                error => {
                    commit('resetPasswordFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    logout({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('logout');

        USERS_SERVICE.logout();
    }
};

const mutations = {
    /* Login */
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;

        // login successful if there's a jwt token in the response
        if (user.data && user.data.accessToken) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));
        }
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    /* Update password */
    updatePasswordRequest(state) {
        state.processTask = null;
    },
    updatePasswordSuccess(state) {
        state.processTask = true;
    },
    updatePasswordFailure(state) {
        state.processTask = false;
    },
    /* Request link */
    linkRequest(state) {
        state.processTask = undefined;
    },
    linkSuccess(state) {
        state.processTask = true;
    },
    linkFailure(state) {
        state.processTask = false;
    },
    /* Reset password */
    resetPasswordRequest(state) {
        state.processTask = null;
    },
    resetPasswordSuccess(state) {
        state.processTask = true;
    },
    resetPasswordFailure(state) {
        state.processTask = false;
    },
    /* */
    logout(state) {
        state.status = {};
        state.user = null;

        localStorage.removeItem('user');
        localStorage.removeItem('locale');

        router.go('/login'); // Force all modules to reset state
    }
};

export const users = {
    namespaced: true,
    state,
    actions,
    mutations
};